import { FileText, FileSpreadsheet, Printer, MessageCircle, Mail } from 'lucide-react';
import { buildDocumentShareText, downloadDetailExcel, downloadDetailPDF } from './documentExportUtils';

export const DocumentExportActions = ({ config, testIdPrefix }) => {
  const shareText = () => buildDocumentShareText(config);
  const shareWhatsApp = () => window.open(
    `https://wa.me/?text=${encodeURIComponent(shareText())}`,
    '_blank',
    'noopener,noreferrer'
  );
  const shareMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(`${config.title} ${config.number || ''}`.trim())}&body=${encodeURIComponent(shareText())}`;
  };
  const buttonClass = 'inline-flex items-center gap-1.5 px-3 py-2 border text-xs font-bold uppercase transition-colors';

  return (
    <div className="flex flex-wrap items-center gap-2 print:hidden" data-testid={`${testIdPrefix}-export-actions`}>
      <button onClick={() => downloadDetailPDF(config)} data-testid={`${testIdPrefix}-pdf-btn`} className={`${buttonClass} border-slate-200 text-slate-700 hover:bg-slate-50`}><FileText className="h-4 w-4" /> PDF</button>
      <button onClick={() => downloadDetailExcel(config)} data-testid={`${testIdPrefix}-excel-btn`} className={`${buttonClass} border-slate-200 text-slate-700 hover:bg-slate-50`}><FileSpreadsheet className="h-4 w-4" /> Excel</button>
      <button onClick={() => window.print()} data-testid={`${testIdPrefix}-print-btn`} className={`${buttonClass} border-slate-200 text-slate-700 hover:bg-slate-50`}><Printer className="h-4 w-4" /> Print</button>
      <button onClick={shareWhatsApp} data-testid={`${testIdPrefix}-whatsapp-btn`} className={`${buttonClass} border-green-300 text-green-700 hover:bg-green-50`}><MessageCircle className="h-4 w-4" /> WhatsApp</button>
      <button onClick={shareMail} data-testid={`${testIdPrefix}-mail-btn`} className={`${buttonClass} border-blue-300 text-blue-700 hover:bg-blue-50`}><Mail className="h-4 w-4" /> Mail</button>
    </div>
  );
};
